import React from 'react';
import logo from '../CCLogo_Black.jpg';
import ClerkMap from '../images/clerkmap.png';

export default function KioskOutcome({ idled, jurorStatus }) {
    const [countDown, setCountDown] = React.useState(15);

    const doReturn = () => {
        window.location.replace('/startup.htm');
    };

    React.useEffect(() => {
        if (countDown < 1) doReturn();
    }, [countDown]);

    const thanks = <p>Thank you for completing your questionnaire.</p>;

    const messages = {
        questionnaireIncomplete: [
            <p>Your questionnaire is incomplete!</p>,
            <p>
                Please <a href="./?kiosk">sign in</a> to complete your questionnaire.
            </p>
        ],
        questionnaireComplete: [thanks, <p>Please return to the window and let the jury clerk know that you have completed your questionnaire.</p>],
        possibleDeferment: [thanks, <p>Please return to the window and let the jury clerk know that you have requested a deferment.</p>],
        deferred: [
            thanks,
            <p>
                Your request for a deferment has been granted. <br /> Please see the jury clerk if you have any questions.
            </p>
        ]
    };

    let message;
    if (idled) message = <p>You have been signed out due to inactivity.</p>;
    else message = messages[jurorStatus] || <p>Please see the jury clerk at the window.</p>;

    const showClerkMap = ['questionnaireComplete', 'possibleDeferment', 'deferred'].some((value) => value === jurorStatus);

    setTimeout(() => {
        setCountDown(countDown - 1);
    }, 999);

    return [
        <div>
            <div>
                <div>
                    <img className="Header-logo" alt="County Logo" src={logo} />
                </div>
                <p />
                <div className="kiosk-outcome kiosk-instruction">
                    <h2 className="kiosk">Jury Questionnaire</h2>
                    <div className="kiosk">{message}</div>
                    <div style={{ paddingLeft: '10px' }}>
                        <button type="button" className="cta_button" onClick={doReturn}>
                            Return
                        </button>
                    </div>
                    {showClerkMap && (
                        <div>
                            <img alt="Clerk Map" src={ClerkMap} />
                        </div>
                    )}
                    <p className="kiosk-countdown">{countDown ? `Exiting in ${countDown} second${countDown === 1 ? '' : 's'}...` : null}</p>
                </div>
            </div>
        </div>
    ];
}
